import { render, staticRenderFns } from "./createmodal.vue?vue&type=template&id=f9b29b0a"
import script from "./createmodal.vue?vue&type=script&lang=js"
export * from "./createmodal.vue?vue&type=script&lang=js"
import style0 from "./createmodal.vue?vue&type=style&index=0&id=f9b29b0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports